import { ReactiveVar } from '@apollo/client';
import { User } from '../../../generated/graphql';

export default function disposeCurrentUser(currentUserVar: ReactiveVar<User | null>) {
  return () => {
    currentUserVar(null);
  };
}
